import CalendarEventsStore from '../../store/CalendarEventsStore';
import getCalendarEventKey from '../../utils/getCalendarEventKey';
import { CalendarEvent, CalendarEventKey } from 'mini-calendar-event-types';
import { eventEmitter, eventsAdded } from 'mini-cal-event-emitters';
import { getCalendarEventsStore } from '../../store/store';
import { userDate } from 'owa-datetime';

/**
 * Internal method that adds events to cache.
 * @param events - Events to add.
 * @returns the calendar keys of events that were added.
 */
export default function addCalendarEventsToCache(events: CalendarEvent[]): CalendarEventKey[] {
    const store: CalendarEventsStore = getCalendarEventsStore();
    const keys: CalendarEventKey[] = [];

    events.forEach(event => {
        convertEventDateInstancesToOwaDate(event);
        store.addCalendarEvent(event);
        keys.push(getCalendarEventKey(event));
    });

    // Emit a signal that calendar events got added to the cache
    eventEmitter.emit(eventsAdded, keys);
    return keys;
}

function convertEventDateInstancesToOwaDate(event: CalendarEvent) {
    event.LastModifiedTime = userDate(event.LastModifiedTime);
    event.Start = userDate(event.Start);
    event.End = userDate(event.End);
    event.AppointmentReplyTime = userDate(event.AppointmentReplyTime);
}
